import { FC } from 'react'
import { ToastManager } from 'react-common'

import { Outlet } from 'react-router-dom'
import { FederationContextProvider } from '@constructor/federation/react'

import { ScrollToTop } from '@/components/ScrollToTop/ScrollToTop'
import { SkipToMainContentButton } from '@/components/SkipToMainContentButton/SkipToMainContentButton'
import { KnowledgeModelWidget } from '@/features/km/KnowledgeModelWidget'
import { NavigationEventBus } from '@/features/microFrontend/NavigationEventBus/NavigationEventBus'
import { useInitMicroFrontends } from '@/features/microFrontend/useInitMicroFrontends'
import { Loading } from './components/Loading/Loading'

const App: FC = () => {
  const { federationRoot } = useInitMicroFrontends()
  return (
    <FederationContextProvider root={federationRoot!}>
      <KnowledgeModelWidget />
      <SkipToMainContentButton />
      <ToastManager />
      <ScrollToTop />
      <Outlet />
      <Loading />
      <NavigationEventBus />
    </FederationContextProvider>
  )
}

export { App }
